<div [ngClass]="compactView ? '' : 'profile_detail'">
  <div [ngClass]="compactView ? '' : 'container clearfix'">
    <div class="row">
      @if (!compactView) {
        <div class="col-lg-3 col-md-5 col-sm-12">
          <profile-left-sidebar></profile-left-sidebar>
        </div>
      }
      <div class="col-md-7 col-md-12" [ngClass]="compactView ? 'col-lg-12' : 'col-lg-9'">
        <div class="row bg-white rounded" [ngClass]="compactView ? '' : 'ml-1'">
          <div class="col-12" [ngClass]="compactView ? 'pr-0' : ''">
            @if (!miniView) {
              <div class="row f14 mx-3 mt-4 mb-3">
                <h3 class="font-weight-bold pl-2 mr-4" style="color: black">Suggestions for you</h3>
                <div class="custom-grey pl-2">You may know these people. Connect with them to start sharing.</div>
                @if (compactView) {
                  <div class="col-11 mx-0 px-0" style="text-align: right; position: absolute">
                    <a href="connection/suggestion" class="view-all theme-blue f13">
                      <strong>
                        <u> View All </u>
                      </strong>
                    </a>
                  </div>
                }
              </div>
            }
            <!-- -------------------- -->
            <div class="row mx-1" id="my-page-1">
              <div class="col-12" [ngClass]="miniView ? 'p-0' : ''">
                <!--normal profile tabs-->
                @for (suggestion of suggestionsData; track suggestion; let index = $index; let last = $last) {
                  <div>
                    <div class="addHover1 mb-2" [ngClass]="!miniView ? 'float-left col-lg-5 mr-lg-5' : 'col-lg-12 pr-0'">
                      <a href="profile/{{ suggestion.user_id }}" style="text-decoration: none">
                        @if (!miniView) {
                          <div class="row align-items-center bg-blue profile">
                            <div class="col-3 p-0" style="overflow: hidden">
                              <img
                                src="{{ suggestion.user_profile_image_url }}"
                                class="m-1"
                                style="max-height: 75px; min-height: 75px"
                                onerror="this.src='./assets/images/dummy-user.jpg';"
                                alt="..."
                                />
                              </div>
                              <div class="col-9 row align-self-start justify-content-between p-3">
                                <div class="pl-3 d-flex flex-column">
                                  <div class="f15 font-weight-bold text-truncate">
                                    {{ suggestion.user_first_middle_name }} {{ suggestion.user_last_name }}
                                  </div>
                                  <div class="custom-light-grey">
                                    <div class="text-truncate">
                                      @if (suggestion.user_country) {
                                        <div>
                                          {{ suggestion.user_country }}
                                        </div>
                                      }
                                      @if (suggestion.MutualConnections > 0) {
                                        <div>Mutual Connections: {{ suggestion.MutualConnections }}</div>
                                      }
                                      @if (!suggestion.user_country) {
                                        <div>
                                          <br /><!-- need an empty div to fix alignment issues when some users have country and others don't -->
                                        </div>
                                      }
                                    </div>
                                  </div>
                                </div>
                                <div class="test-plus pt-3">
                                  <button data-toggle="modal" data-target="#sendCon">
                                    <img
                                      src="./assets/images/reject.svg"
                                      style="transform: rotate(45deg); align-self: center"
                                      (click)="openConnectModal(suggestion)"
                                      />
                                    </button>
                                  </div>
                                  <div class="position-absolute col-4 d-flex justify-content-end h-100" style="z-index: 5; right: -20px; top: -4px">
                                    <img
                                      src="./assets/images/close.svg"
                                      class="mt-2 mr-n1"
                                      style="align-self: start"
                                      (click)="ignoreSuggestion(suggestion.user_id)"
                                      />
                                    </div>
                                  </div>
                                </div>
                              }
                              @if (miniView) {
                                <div class="row border align-items-center justify-content-start p-1 suggestions mb-2 w-100 position-relative">
                                  <div class="position-absolute col-4 d-flex justify-content-end h-100" style="z-index: 5; right: -4px">
                                    <button class="p-0 bg-white" data-toggle="modal" data-target="#sendCon">
                                      <img
                                        src="./assets/images/reject.svg"
                                        class="mr-2"
                                        height="20px"
                                        style="transform: rotate(45deg); align-self: center"
                                        (click)="openConnectModal(suggestion)"
                                        />
                                      </button>
                                      <img
                                        src="./assets/images/close.svg"
                                        class="mt-2 mr-n1"
                                        style="align-self: start"
                                        (click)="ignoreSuggestion(suggestion.user_id)"
                                        />
                                      </div>
                                      <div class="col-2 p-0 overflow-hidden text-left">
                                        <img
                                          class=""
                                          src="{{ suggestion.user_profile_image_url }}"
                                          alt="..."
                                          style="max-height: 40px; min-height: 40px"
                                          onerror="this.src='./assets/images/dummy-user.jpg';"
                                          />
                                        </div>
                                        <div class="col-9">
                                          <div class="row align-items-center">
                                            <div class="col-11 text-left pl-1">
                                              <div class="text-truncate" title="{{ suggestion.user_first_middle_name }} {{ suggestion.user_last_name }}">
                                                <b>{{ suggestion.user_first_middle_name }} {{ suggestion.user_last_name }}</b>
                                              </div>
                                              @if (suggestion.MutualConnections > 0) {
                                                <div
                                                  class="text-truncate custom-light-grey"
                                                  style="font-size: 10px"
                                                  title="Mutual connections: {{ suggestion.MutualConnections }}"
                                                  >
                                                  Mutual connections: {{ suggestion.MutualConnections }}
                                                </div>
                                              }
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                  </a>
                                </div>
                              </div>
                            }
                            <!--normal profile tabs-->
                          </div>
                        </div>
                        <!----------------------- -->
                        @if (!compactView && suggestionPages.length > 1) {
                          <div class="justify-content-center my-pages row px-0">
                            <!--<nav aria-label="...">-->
                            <div class="holder theme-blue f13">
                              <!--<div class="page_navigation theme-blue"></div>-->
                              <ul class="col-12 justify-content-start itemContainer row theme-blue p-0 m-0" style="list-style-type: none">
                                <li class="page-item" [ngClass]="suggestionPageCurrentIndex == 1 ? 'disabled' : ''">
                                  <a class="page-link border-0 rounded jp-previous" (click)="changePage('pre')">Previous</a>
                                </li>
                                @for (page of suggestionPages; track page; let index = $index; let last = $last) {
                                  <li
                                    class="page-item"
                                    [ngClass]="page.pageIndex == suggestionPageCurrentIndex ? 'active' : ''"
                                    (click)="changePage(page.pageIndex)"
                                    >
                                    <a class="page-link border-0 rounded jp-first">{{ page.pageIndex }}</a>
                                  </li>
                                }
                                <!-- <li class="page-item"><a class="page-link border-0 rounded jp-hidden" href="#"><span class="fa fa-ellipsis-h rounded"></span></a></li> -->
                                <li class="page-item jp-next" [ngClass]="suggestionPageCurrentIndex == suggestionPages.length ? 'disabled' : ''">
                                  <a class="page-link border-0 rounded jp-next" (click)="changePage('next')">Next</a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        }

                        @if (!compactView) {
                          <div class="row ml-1 p-4 f13 custom-grey justify-content-start">
                            <strong
                              >Can't find the person you are looking for?
                              <a href="#" class="theme-blue" data-toggle="modal" data-target="#inviteUser" (click)="openInviteDialog()">
                                <u> Invite them to Kinnect </u>
                              </a></strong
                              >
                            </div>
                          }
                          @if (miniView && !hideMiniShowAll) {
                            <div class="col-11 mx-0 px-0" style="text-align: center">
                              <a href="connection/suggestion" class="view-all theme-blue f13">
                                <strong>
                                  <u> View All </u>
                                </strong>
                              </a>
                            </div>
                          }
                        </div>
                      </div>
                      <!-- SUGGESTIONS -->
                    </div>
                  </div>
                </div>
              </div>
